import { render, staticRenderFns } from "./Tab_Measurements.vue?vue&type=template&id=59a1a8a2&v-if=customer"
import script from "./Tab_Measurements.vue?vue&type=script&lang=js"
export * from "./Tab_Measurements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports